import React from "react";

/**
 * EuroPilot "Daggry" brand mark — inline SVG.
 *
 * Default render is static (sun already risen).
 * Pass `animate` to play a one-shot sunrise entrance on mount:
 *   • coral sun rises from below the horizon (clipped, so it appears to emerge)
 *   • horizon line scales in from the centre
 *   • paper plane glides in from the right
 *
 * Animation respects `prefers-reduced-motion`.
 */
export const DaggryMark = ({ size = 32, animate = false, className = "" }) => {
  // Stable per-instance id so multiple marks on a page don't collide.
  const id = React.useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      role="img"
      aria-label="EuroPilot"
      className={`daggry-mark ${animate ? "daggry-animate" : ""} ${className}`}
      data-testid="daggry-mark"
    >
      <defs>
        <clipPath id={`hz-${id}`}>
          {/* Clip everything above the bottom of the horizon line. The sun
              starts below this clip and rises into view. */}
          <rect x="0" y="0" width="96" height="66" />
        </clipPath>
      </defs>
      {/* Navy night-sky disc */}
      <circle cx="48" cy="48" r="46" fill="#0B2440" />
      {/* Sun — clipped so it appears to rise from behind the horizon */}
      <g clipPath={`url(#hz-${id})`}>
        <circle cx="48" cy="64" r="20" fill="#FF8A5C" className="daggry-sun" />
      </g>
      {/* Horizon line */}
      <rect x="14" y="62" width="68" height="4" rx="2" fill="#FFE9DC" className="daggry-horizon" />
      {/* Paper plane */}
      <path
        d="M22 50 L74 30 L60 56 L52 48 L34 52 Z"
        fill="#FFE9DC"
        className="daggry-plane"
      />
    </svg>
  );
};

export default DaggryMark;
